<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p>{{text}}</p>

  <div>


    <div>
      <small>Reason</small>
      <mat-select [(ngModel)]="reason" placeholder="Select a reason">
        <mat-option [value]="'serving_sentence'">Serving a sentence</mat-option>
        <mat-option [value]="'being_arrested'">Being arrested</mat-option>
        <mat-option [value]="'addiction'">Addiction (Drugs, alcohol, ...)</mat-option>
        <mat-option [value]="'financial_difficulties'">Financial difficulties</mat-option>
        <mat-option [value]="'mental_health'">Mental Health issues (Depression, anxiety, ...)</mat-option>
        <mat-option [value]="'mental_capacity'">Mental incapacity (Alzheimers, dementia, ...)</mat-option>
        <mat-option [value]="'other'">Other</mat-option>
      </mat-select>
    </div>

  </div>

</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="onCancelClick()" cdkFocusInitial color="basic">Cancel</button>
  <button mat-raised-button (click)="onOkClick()" [disabled]="!this.reason" color="primary">Ok</button>
</div>
